import { ref } from 'vue';

// eslint-disable-next-line
const selectedRegion = ref(null);
const availableRegions = ref(null);

const changeSelectedRegion = (newRegionToSelect) => {
  selectedRegion.value = newRegionToSelect;
};

export default function (regions) {
  availableRegions.value = regions;

  return {
    availableRegions,
    selectedRegion,
    changeSelectedRegion,
  };
}
